import React from 'react';
import intl from "react-intl-universal";


import {useAppState} from "@stores/AppStateContext";

import {useEditorState} from '../../provider';
import {docIsEmpty} from "../../../../../utils/docIsEmpty";

export const EmptyPlaceHolder = () => {
    const appState = useAppState();
    const rootStore = appState.rootStore;
    const userState = appState.userState!;

    const state = useEditorState();

    const isEmpty = docIsEmpty(state);

    if (userState?.isCurrentUserReadOnly) {
        return null
    }

    return (
        <div
            key={rootStore.currentLocale}
            className="ER-empty-note"
            style={{
                display: isEmpty ? 'block' : 'none'
            }}
        >
            {intl.get('empty_document.placeholder').d('Start typing here. Type / to open the context menu of the editor')}
        </div>
    )
}
